import Vue from 'vue'
import ShoppingCart from './components/ShoppingCart.vue'
import vueCustomElement from 'vue-custom-element'

Vue.use(vueCustomElement);

Vue.customElement('shopping-cart', ShoppingCart, { shadow: false })
